import React, { useEffect, useState } from 'react';
import './Dropdown.scss';
import PropTypes from 'prop-types';

const Dropdown = ({
  customClass,
  title,
  icon,
  chevron,
  children,
  isDropdownAvailable,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = React.createRef();
  const hoverClass = isOpen ? 'hover-background' : '';
  const handleClickOutside = (event) => {
    if (ref && ref !== null) {
      const cur = ref.current;
      if (cur && !cur.contains(event.target)) {
        setIsOpen(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  });
  const handleOpenDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`custom-dropdown ${customClass} ${hoverClass}`} onClick={handleOpenDropdown}
         ref={ref}>
      <div className="title">
        {icon && icon}
        <span className="title-label">{title}</span>
        {chevron && chevron}
      </div>
      {isOpen && isDropdownAvailable &&
      <div className="dropdown-container">
        {children}
      </div>}
    </div>
  );
};

export default Dropdown;

Dropdown.propTypes = {
  customClass: PropTypes.string,
  title: PropTypes.string,
  isDropdownAvailable: PropTypes.bool,
};

Dropdown.defaultProps = {};

